<template>
    <!-- Travel period -->
    <div class="travel-period-picker dropdown" :class="{ inline: inline }">
        <div class="search-component h-100" :class="{ open: isCheckInOpen }" v-if="! inline">
            <button class="btn not d-flex flex-row align-items-center" type="button" @click="toggleCheckIn" data-reference="nav.search-navbar">
                <span class="d-inline-flex flex-column flex-grow-1">
                    <span class="label-text">
                        {{ 'search.travelPeriodPicker.arrivalLabel' | trans }}
                    </span>

                    <span class="date-text" v-if="period !== null && period.from">
                        {{ period.from.format('Do MMM') }}
                    </span>

                    <span class="date-text" v-if="period === null">
                        {{ 'search.travelPeriodPicker.anytime' | trans }}
                    </span>
                </span>
            </button>
        </div>

        <div class="search-component h-100" :class="{ open: isCheckOutOpen }" v-if="! inline">
            <button class="btn not d-flex flex-row align-items-center" type="button" @click="toggleCheckOut" data-reference="nav.search-navbar">
                <span class="d-inline-flex flex-column flex-grow-1">
                    <span class="label-text">
                        {{ 'search.travelPeriodPicker.returnLabel' | trans }}
                    </span>

                    <span class="date-text" v-if="period !== null && period.to">
                        {{ period.to.format('Do MMM Y') }}
                    </span>

                    <span class="date-text" v-if="period === null || (period && ! period.to)">
                        {{ 'search.travelPeriodPicker.anytime' | trans }}
                    </span>
                </span>
            </button>
        </div>

        <div class="search-component h-100 inline" :class="{ open: isCheckInOpen }" v-if="inline">
            <button class="btn not d-flex flex-row align-items-center" type="button" @click="toggleCheckIn" data-reference="nav.search-navbar">
                <!-- Icon -->
                <i class="icon far fa-calendar" v-if="inline"></i>

                <span class="date-text" v-if="period === null">
                    {{ 'search.travelPeriodPicker.selectPeriod' | trans }}
                </span>

                <span class="date-text" v-if="period !== null && period.from">
                    {{ period.from.format('DD.MM.') }}
                    -
                </span>

                <span class="date-text" v-if="period !== null && period.to">
                    &nbsp;
                    {{ period.to.format('DD.MM.') }}
                </span>
            </button>
        </div>

        <div class="dropdown-menu period-picker" :class="{ show: isCheckInOpen || isCheckOutOpen }">
            <input id="periodPicker" />
            <div class="periodCalendar"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['inline', 'originPeriod'],
        data() {
            return {
                isCheckInOpen: false,
                isCheckOutOpen: false,
                period: null,
            }
        },
        mounted() {
            var self = this

            // Travel period
            $('input#periodPicker').dateRangePicker({
                separator: ' to ',
                inline: true,
                container: $('div.periodCalendar'),
                alwaysOpen: true,
                stickyMonths: true,
                language: 'de',
                startDate: new Date(),
                startOfWeek: 'monday',
                showTopbar: false,
                customArrowPrevSymbol: '<button type="button" class="btn"><i class="fa fa-chevron-left"></i></button>',
                customArrowNextSymbol: '<button type="button" class="btn"><i class="fa fa-chevron-right"></i></button>',
                hoveringTooltip: (days) => {
                    return `${self.$options.filters.choice('search.travelPeriodPicker.daysTooltip', days, { days: days })} (${self.$options.filters.choice('search.travelPeriodPicker.nightsTooltip', days - 1, { nights: days - 1 })})`
                },
            })
            .bind('datepicker-first-date-selected', function(event, data) {
                self.period = {
                    from: moment(data.date1),
                    to: null
                }
                self.$emit('changeTravelPeriod', self.period)
                self.toggleCheckOut()
            })
            .bind('datepicker-change', function(event, data) {
                self.period = {
                    from: moment(data.date1),
                    to: moment(data.date2)
                };

                self.$emit('changeTravelPeriod', self.period)
                self.hideDropdown()
            });

            this.loadOrigin()
        },
        computed: {},
        methods: {
            loadOrigin() {
                // Keep origin period
                if (this.originPeriod && this.originPeriod.from && this.originPeriod.to) {
                    this.period = Object.assign({}, this.originPeriod)

                    $('input#periodPicker').data('dateRangePicker')
                    .setDateRange(this.period.from.format('YYYY-MM-DD'), this.period.to.format('YYYY-MM-DD'));
                }
            },
            hideDropdown() {
                this.isCheckInOpen = false
                this.isCheckOutOpen = false
            },
            toggleCheckIn() {
                this.$root.$refs.search.hideDropdowns('travelPeriodPicker')
                this.isCheckOutOpen = false
                this.isCheckInOpen = ! this.isCheckInOpen
            },
            toggleCheckOut() {
                this.$root.$refs.search.hideDropdowns('travelPeriodPicker')
                this.isCheckInOpen = false
                this.isCheckOutOpen = ! this.isCheckOutOpen
            },
            setTravelPeriod(period) {
                this.period = period

                if (period) {
                    $('input#periodPicker').data('dateRangePicker')
                    .setDateRange(period.from.format('YYYY-MM-DD'), period.to.format('YYYY-MM-DD'));
                } else {
                    $('input#periodPicker').data('dateRangePicker').clear();
                }
            },
        },
        watch: {
            originPeriod: {
                handler(val) {
                    if (val && val.from && val.to && ! this.$lodash.isEqual(val, this.period)) {
                        this.period = Object.assign({}, val)

                        $('input#periodPicker').data('dateRangePicker')
                        .setDateRange(this.period.from.format('YYYY-MM-DD'), this.period.to.format('YYYY-MM-DD'));
                    }
                },
                deep: true,
            }
        }
    }
</script>
